export const TABS = {
  CALENDAR: "calendar",
  REQUESTS: "requests",
  PROFILE: "profile",
};
